<div class="queue-table table-responsive">
    <table class="table table-sm table-borderless">
      <thead>
        <tr>
          <th>Machine Type</th>
          <th class="text-center">Instance ID</th>
          <th class="text-center">IP address</th>
          <th class="text-center">Start Time</th>
          <th class="text-center">End Time</th>
          <th class="text-center">Max. CPU Utilization</th>
          <th class="text-center"> Machine Status</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let machine of machineList">
          <td>{{ machine.performanceInstanceType }}</td>
          <td class="text-center">{{ machine.instanceId }}</td>
          <td class="text-center">{{ machine.ipaddress }}</td>
          <td class="text-center">{{ machine.startTime || '-' }}</td>
          <td class="text-center">{{ machine.endTime || '-' }}</td>
          <td class="text-center">{{ machine.maxCPUUsage || '-' }}</td>
          <td class="text-center">{{machine.instanceState || '-'}}</td>
        </tr>
        <tr *ngIf="!machineList || machineList.length === 0">
          <td colspan="6" class="text-center">No machines found for this execution</td>
        </tr>
      </tbody>
    </table>
  </div>
  